import Offcanvas from "bootstrap/js/dist/offcanvas";

export default function navigationInit() {
    const mobileMenuToggle = document.querySelector(".animated-toggler");
    const bsOffcanvas = new Offcanvas("#offcanvas-navbar");

    mobileMenuToggle.addEventListener("click", () => {
        mobileMenuToggle.classList.add("opened");
        // Delay mobile menu show until after toggle animation finishes
        setTimeout(() => {
            bsOffcanvas.show();
        }, 350);
    });

    // Remove .opened class from toggler after mobile menu finishes closing
    document.querySelector("#offcanvas-navbar").addEventListener("hidden.bs.offcanvas", () => {
        mobileMenuToggle.classList.remove("opened");
    });
}
